import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-project-gallery',
  templateUrl: './project-gallery.component.html',
  styleUrls: ['./project-gallery.component.css']
})
export class ProjectGalleryComponent implements OnInit {
  @Input() galleryItems: any[];
  currentIndex: number = 0;
  // downscaledGalleryItems = [];
  // maxWidth: number = 100;
  // maxHeight: number = 100;

  constructor() { }

  ngOnInit(): void {}

  get currentItem(): string | any[] {
    return this.galleryItems[this.currentIndex];
  }

  next() {
    if (this.currentIndex < this.galleryItems.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0;
    }
  }

  previous() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.galleryItems.length - 1;
    }
  }

  // downscaleImage(image: HTMLImageElement, maxWidth: number, maxHeight: number): HTMLCanvasElement {
  //   const canvas = document.createElement('canvas');
  //   const ctx = canvas.getContext('2d')!;
  //   let width = image.width;
  //   let height = image.height;

  //   // Maintain aspect ratio
  //   if (width > height) {
  //     if (width > maxWidth) {
  //       height = Math.round(height * (maxWidth / width));
  //       width = maxWidth;
  //     }
  //   } else {
  //     if (height > maxHeight) {
  //       width = Math.round(width * (maxHeight / height));
  //       height = maxHeight;
  //     }
  //   }

  //   canvas.width = width;
  //   canvas.height = height;
  //   ctx.drawImage(image, 0, 0, width, height);
  //   return canvas;
  // }

  // getImage(image: HTMLImageElement): string {
  //   const canvas = this.downscaleImage(image, this.maxWidth, this.maxHeight);
  //   return canvas.toDataURL('image/jpeg');
  // }

  // loadAndDownscaleImages() {
  //   this.galleryItems.forEach((item, index) => {
  //     if (item.type == 'image') {
  //       const img = new Image();
  //       img.src = item.url;
  //       img.onload = () => {
  //         const downscaledImage = this.getImage(img); // maxWidth and maxHeight
  //         this.downscaledGalleryItems[index] = item;
  //         this.downscaledGalleryItems[index].url = downscaledImage;
  //         if (index == this.galleryItems.length - 1) {
  //           this.displayItems = true;
  //         }
  //       };
  //     }
  //     else {
  //       this.downscaledGalleryItems[index] = item;
  //     }
  //   });
  // }

}
